import { useEffect, useState } from "react";
import styled from "styled-components";
import ButtonMenu from "../../../mobile/interface/ButtonMenu";
import { SlInfo } from "react-icons/sl";
import { BsCalendar2Range, BsGraphUpArrow } from "react-icons/bs";
import { FaRobot } from "react-icons/fa";
import { GrNotes, GrDocumentStore } from "react-icons/gr";
import { GoReport } from "react-icons/go";
import { useUrlNavigation } from "./useUrlNavigation";
import { getViewComponent } from "./utils/viewMapping";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  align-items: center;
  margin-top: -3rem;
  height: 100vh;
  width: 100vw;

  // Background Image properties
  background-image: url("/images/ScannerDuck.png");
  background-size: cover; // Ensures the image covers the whole container (zoom effect)
  background-position: center; // Center the image
  background-size: contain;
  background-repeat: no-repeat; // Prevent the image from repeating
  background-attachment: scroll; // Keeps the image fixed during scrolling (optional)
  overflow: hidden;
  @media (max-width: 768px) {
    background-size: contain;
  }
  @media (max-width: 480px) {
    background-size: cover;
  }
`;

const Heading = styled.header`
  font-size: 2em;
  font-weight: 700;
  margin-bottom: 2rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 5rem;
`;

const ButtonContainer = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

function MMachineInfo() {
  const { getParam, setView } = useUrlNavigation();
  const [machine, setMachine] = useState(getParam("m"));
  const [currentView, setCurrentView] = useState(getParam("view")); // Sync initial state with URL

  // Get ViewComponent dynamically based on currentView state
  const ViewComponent = getViewComponent(currentView);

  // Update view state based on URL changes (Back/Forward navigation)
  useEffect(() => {
    const viewFromUrl = getParam("view");
    const machineFromUrl = getParam("m");
    setCurrentView(viewFromUrl);
    setMachine(machineFromUrl);
  }, [getParam]);

  // Function to handle button clicks to switch views
  const handleButtonClick = (viewName) => {
    setCurrentView(viewName); // Set active view to the clicked button’s view
    setView(viewName, machine); // Update URL to reflect the selected view
  };

  return (
    <Container>
      {ViewComponent ? (
        <ViewComponent /> // Render only if currentView is set
      ) : (
        <>
          <Heading>{machine}</Heading>
          <ButtonGroup>
            <ButtonContainer>
              <ButtonMenu icon={<SlInfo />}>Key Info</ButtonMenu>
              <ButtonMenu icon={<GrDocumentStore />}>Documents</ButtonMenu>
              <ButtonMenu
                icon={<BsCalendar2Range />}
                onClick={() => handleButtonClick("orders")}
              >
                Work Orders
              </ButtonMenu>
            </ButtonContainer>
            <ButtonContainer>
              <ButtonMenu icon={<BsGraphUpArrow />}>KPI and Stats</ButtonMenu>
              <ButtonMenu
                icon={<FaRobot />}
                onClick={() => handleButtonClick("faults")}
              >
                Machine Faults
              </ButtonMenu>
            </ButtonContainer>
            <ButtonContainer>
              <ButtonMenu icon={<GoReport />}>Report Fault</ButtonMenu>
              <ButtonMenu icon={<GrNotes />}>Notes</ButtonMenu>
            </ButtonContainer>
          </ButtonGroup>
        </>
      )}
    </Container>
  );
}

export default MMachineInfo;
